export default {"src":"/_next/static/media/deco_checkout_successcheckmark.ebafcc36.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};